import {Col, Row} from "react-bootstrap";

export function LabelWithInput(props) {
    const {title, children, reverse} = props;
    return <Row className={'me-1 mt-1'}>
        {reverse ?
            <>
                <Col xs={'auto'}>{children}</Col>
                <Col>{title}</Col>
            </> :
            <>   <Col xs={12}>{title}</Col>
                <Col xs={12}>{children}</Col> </>
        }

    </Row>
}